import React from "react";

import classnames from "classnames";
import { Field } from "formik";
import PropTypes from "prop-types";

import styles from "./Checkbox.module.scss";

function CheckboxComponent({
  label,
  name,
  checked,
  onChange,
  onBlur,
  required,
  className,
  ...props
}) {
  return (
    <div className={classnames(styles.container, className)}>
      <input
        className={styles.input}
        id={name}
        type="checkbox"
        checked={checked}
        required={required}
        onChange={onChange}
        onBlur={onBlur}
        {...props}
      />
      <label className={styles.label} htmlFor={name}>
        <span>{label}</span>
      </label>
    </div>
  );
}

const checkboxPropTypes = {
  checked: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  className: PropTypes.string,
  noForm: PropTypes.bool,
};

const checkboxDefaultProps = {
  label: null,
  required: false,
};

CheckboxComponent.propTypes = checkboxPropTypes;

CheckboxComponent.defaultProps = checkboxDefaultProps;

function Checkbox({ noForm, ...props }) {
  // Pure component
  if (noForm) {
    return <CheckboxComponent {...props} />;
  }
  // With Formik
  return (
    <Field name={props.name}>
      {({ field }) => {
        const { value: checked, ...others } = field;
        return <CheckboxComponent checked={checked} {...props} {...others} />;
      }}
    </Field>
  );
}

Checkbox.propTypes = checkboxPropTypes;

Checkbox.defaultProps = checkboxDefaultProps;

Checkbox.styles = styles;

export default Checkbox;
